<div class="otp-container"
     dir="ltr">
  <input
    #otpBox
    (input)="onInput($event, i)"
    (keydown)="onKeydown($event, i)"
    (paste)="onPaste($event, i)"
    *ngFor="let _ of boxes; let i = index"
    [value]="otp[i]"
    autocomplete="one-time-code"
    class="otp-box"
    inputmode="numeric"
    maxlength="1"
    pattern="[0-9]*"
    type="text"
  />
</div>
